/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/prefer-default-export */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Col, HStack, Row } from "./Layout";
import close from "../assets/close.svg";
import { Modal } from "./Modal/Modal";
import { IDialogInfo } from "./Icons";
import { Button } from "./Button";
import { clearSessionStorage } from "../utils/Storage";

const Logo = require("../theme/assets/logo.png");

type navbarProps = {
  brand?: any;
  title?: string;
  children?: React.ReactNode;
  renderMenu?: React.ReactNode;
};

interface ExitCaptureProps {
  onCancel: () => void;
  onProceed: () => void;
}

const ExitCapture: React.FunctionComponent<ExitCaptureProps> = ({ onCancel, onProceed }: ExitCaptureProps) => (
  <div className="d-flex direction-col justify-content-center direction-row px-4">
    <Box className="px-0 pb-4">
      <div className="d-flex direction-col align-items-center">
        <IDialogInfo />
        <Row style={{ justifyContent: "center" }}>
          <Col sm="12" md="10" lg="8">
            <div className="dialog-title pb-4">Are you sure you want to leave?</div>
            <div className="dialog-description pb-4">
              If you leave this page, your progress will not be saved and you will need to create a new invoice.
            </div>
          </Col>
        </Row>
        <div>
          <div id="mobile-buttons">
            <div className="pb-2">
              <Button className="text-size-18" label="Continue with invoice" size="medium" onClick={() => onCancel()} />
            </div>
            <HStack className="pb-2 justify-content-center">
              <button
                type="button"
                className="cancel-button pl-5 my-0 ml-1 mr-5 text-size-18 text-medium clickable"
                onClick={() => onProceed()}
              >
                Leave page
              </button>
            </HStack>
          </div>
          <div id="desktop-buttons">
            <Button
              className="text-size-18"
              label="No, continue invoice"
              varient="secondary"
              size="medium"
              onClick={() => onCancel()}
            />
            <Button className="text-size-18 ml-8" label="Yes, exit invoice" size="medium" onClick={() => onProceed()} />
          </div>
        </div>
      </div>
    </Box>
  </div>
);

export const Navbar = (props: navbarProps | undefined) => {
  if (!props) return <></>;

  const { brand, title } = props;
  const [isModalOpen, setModalOpen] = useState(false);

  const navigate = useNavigate();
  const handleClose = () => {
    setModalOpen(!isModalOpen);
  };

  const cancel = () => {
    setModalOpen(false);
  };

  const stopProgress = () => {
    setModalOpen(false);
    clearSessionStorage();
    navigate("/");
  };

  return (
    <>
      <nav className="navbar">
        <img className="brand" src={brand || Logo} alt="Brand image" />
        <div className="title">{title}</div>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
        <img className="edit pr-4" src={close} alt="close" onClick={handleClose} onKeyDown={handleClose} />
      </nav>
      <Modal isOpen={isModalOpen} content={<ExitCapture onCancel={cancel} onProceed={stopProgress} />} />
    </>
  );
};

Navbar.defaultProps = {
  title: "portal",
};
